import OrderList from 'modules/Orders/components/OrderList'

export const RestaurantsOrders = () => {
  return <OrderList />
}
